import { Calendar as PrimeCalendar } from "primereact/calendar";

import type { CalendarViewProps } from "./types-calendar";

export function CalendarView({ calendarRef, calendarProps }: CalendarViewProps) {
  return <PrimeCalendar ref={calendarRef} {...calendarProps} />;
}
